import React, { useEffect, useState } from "react";
import styled from "styled-components";
import nooruLogo from "./assets/nooru_logo.png";
import nooruText from "./assets/nooru_text.png";
import nooruSymbol from "./assets/nooru_symbol.png";
import PromoBanner from "./PromoBanner";
import BottomForm from "./BottomForm";
import ReactGA from "react-ga4";
import ReactPixel from "react-facebook-pixel";

// Styled Components
const Container = styled.div`
  font-family: "Arial", sans-serif;
`;

const Wrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

const Header = styled.header`
  padding: 20px;
  background-color: #fff;
  .wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 15px;
    .wrap {
      justify-content: center;
    }
  }
`;

const Logo = styled.img`
  width: 70px;

  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
`;

const Nav = styled.nav`
  text-align: center;
  ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
  }

  li {
    margin: 0 20px;
  }

  a {
    text-decoration: none;
    color: #000;
  }

  @media (max-width: 768px) {
    width: 100%;

    display: none;
    ul {
      flex-direction: column;
      align-items: center;
    }

    li {
      margin: 8px 0;
    }
  }
`;

const HeroSection = styled.section`
  text-align: center;
  padding: 100px 0 200px;
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 30px 15px 70px;
  }
`;

const HeroHeading = styled.h1`
  font-size: 2.5rem;
  color: #333;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    line-height: 1.3;
  }
`;

const HeroSubHeading = styled.p`
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: rgba(107, 114, 128, 1);

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 15px;
  }
`;

const CTAButton = styled.button`
  background-color: rgb(88, 80, 236);
  border-radius: 3px;
  color: white;
  padding: 15px 20px;
  border: none;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background-color: #3700b3;
  }

  @media (max-width: 768px) {
    padding: 12px 18px;
    font-size: 0.9rem;
  }
`;

const FeaturesSection = styled.section`
  padding: 100px 0 100px;
  background-color: rgb(60, 13, 153);

  @media (max-width: 768px) {
    padding: 30px 15px;
  }
`;

const FeatureCard = styled.div`
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    width: 30%;
  }
`;

const FeatureSectionTitle = styled.h3`
  font-size: 1.5rem;
  color: #fff;
  font-family: "Open Sans";
  font-weight: 400;
  text-align: center;
  margin-bottom: 20px;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

const FeatureTitle = styled.h3`
  text-align: center;
  font-family: "Inter";
  font-size: 36px;
  font-weight: 800;
  color: rgba(255, 255, 255, 1);

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const FeatureDescription = styled.p`
  font-family: "Inter";
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 14px;
    flex-direction: column;
    line-height: 1.5;
  }
`;

const BenefitSection = styled.section`
  background-color: #fff;
  padding: 100px 0;

  @media (max-width: 768px) {
    padding: 50px 15px;
  }
`;

const BenefitTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 20px;
  color: rgba(2, 5, 211, 1);

  @media (max-width: 768px) {
    font-size: 1.7rem;
  }
`;

const BenefitList = styled.ul`
  list-style: none;
  margin: 20px 0;
  padding: 0;

  li {
    margin: 15px 0;

    h4 {
      font-family: "Inter";
      font-size: 18px;
      font-weight: 600;
      color: rgba(22, 30, 46, 1);
      line-height: 1.3;
      margin-bottom: 10px;
    }

    p {
      font-family: "Inter";
      font-size: 16px;
      font-weight: 400;
      color: rgba(107, 114, 128, 1);
      line-height: 1.5;
      margin-bottom: 10px;
    }
  }

  @media (max-width: 768px) {
    li {
      h4 {
        font-size: 16px;
      }

      p {
        font-size: 14px;
      }
    }
  }
`;

const PricingSection = styled.section`
  padding: 50px 0;
  background-color: rgb(244, 245, 247);
  text-align: center;

  @media (max-width: 768px) {
    padding: 30px 30px;
  }
`;

const PricingTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    font-size: 1.7rem;
    margin-bottom: 30px;
  }
`;

const PricingCards = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const MOSTBadge = styled.div`
  position: absolute;
  top: 8px;
  border-radius: 15px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgb(88, 80, 236);
  color: white;
  padding: 5px 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: 500;
`;

const PricingCard = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 20px 0 0;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  border-radius: 10px;
  border: ${(props) => (props.mostPopular ? "2px solid #4a00e0" : "none")};
  margin-bottom: 20px;

  @media (min-width: 768px) {
    width: 30%;
  }
`;

const PricingCardDescription = styled.p`
  font-family: "Inter";
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
  color: rgba(107, 114, 128, 1);
  text-align: center;
  line-height: 1.3;
  margin-bottom: 20px;
`;

const PricingCardTitle = styled.h3`
  font-size: 1.5rem;
  color: ${(props) => (props.mostPopular ? "#4a00e0" : "#333")};
`;

const PricingCardPrice = styled.p`
  font-family: "Inter";
  font-size: 44px;
  font-weight: 900;
  color: rgba(22, 30, 46, 1);
  text-align: center;
  line-height: 1.2;
  margin: 20px 0;

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

const PricingCardFeatures = styled.ul`
  list-style: none;
  padding: 20px 0 40px;
  background-color: rgb(249, 250, 251);
  border-top-style: solid;
  border-top-width: 1px;
  border-top-color: rgba(230, 230, 230, 1);

  li {
    margin: 10px 0 15px;
    text-align: left;
    padding: 0 20px;
    font-family: "Inter";
    font-size: 16px;
    font-weight: 400;
    color: rgba(107, 114, 128, 1);
    line-height: 1.2;
  }

  @media (max-width: 768px) {
    li {
      font-size: 14px;
      line-height: 1.4;
    }
  }
`;

const StartTrialButton = styled.button`
  background-color: rgb(229, 237, 255);
  color: rgba(88, 80, 236, 1);
  padding: 14px 20px;
  border: none;
  width: calc(100% - 40px);
  margin: 0 20px;
  border-radius: 5px;
  cursor: pointer;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  transition: all 0.5s;

  margin-top: 20px;
  &:hover {
    background-color: #3700b3;
    color: white;
  }

  ${(props) =>
    props.mostPopular &&
    `
    background-color: rgb(88, 80, 236);
    color: white;

    &:hover {
      background-color: rgb(70, 64, 189);
    }
  `}

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 12px 18px;
  }
`;

const Footer = styled.footer`
  background-color: rgb(244, 245, 247);
  font-family: "Inter";
  font-size: 12px;
  font-weight: 300;
  color: rgba(107, 114, 128, 1);
  word-spacing: 1px;
  text-align: center;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 20px 15px;
  }
`;

const SocialLinks = styled.div`
  margin: 20px 0;

  a {
    color: #333;
    margin: 0 10px;
    text-decoration: none;
  }
`;

const HeroContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0 15px;
  }
`;

const HeroTextContainer = styled.div`
  flex: 1;
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
    margin-bottom: 20px;
  }
`;

const HeroImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const HeroImage = styled.img`
  max-width: 100%;
  height: auto;
`;

const VisualBox = styled.div`
  width: 180px;
  height: 90px;
  background-color: rgb(60, 13, 153);
  border-radius: 6px;
  position: absolute;
  top: -60px;
  left: 20px;
  @media (max-width: 768px) {
    display: none;
  }
`;

const VisualWhiteBox = styled.div`
  width: 150px;
  height: 70px;
  background-color: rgb(255, 255, 255);
  border-radius: 6px;
  position: absolute;
  top: -25px;
  left: 80px;
  @media (max-width: 768px) {
    display: none;
  }
`;

// Main Component
function MainPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const openModal = (plan, skip = false) => {
    if (!skip) {
      ReactGA.event({
        category: "Button",
        action: "Click",
        label: `Open Modal - ${plan}`,
      });
    }
    setSelectedPlan(plan);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    // Facebook Pixel 초기화
    ReactPixel.init(process.env.REACT_APP_PIXEL_ID);
  }, []);

  return (
    <Container>
      {/* Header Section */}
      <Header>
        {/* <Wrapper> */}
        <div class="wrap">
          <Logo src={nooruSymbol} alt="Logo" />
          <Nav>
            <ul>
              <li>
                <a href="#benefit">Benefit</a>
              </li>
              <li>
                <a href="#pricing">Pricing</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </Nav>
        </div>
        {/* </Wrapper/</Container>> */}
      </Header>

      {/* Hero Section */}
      <HeroSection>
        <Wrapper>
          <HeroContent>
            <HeroTextContainer>
              <HeroHeading>
                「誰でも簡単に
                <br />
                韓国語が学べる！
                <br />
                独学でも
                <br />
                <b style={{ color: "rgb(88, 80, 236)" }}>発音バッチリ！</b>
              </HeroHeading>
              <HeroSubHeading>独学でも発音バッチリ！</HeroSubHeading>
              <CTAButton
                onClick={() => {
                  ReactGA.event({
                    category: "Button",
                    action: "Click",
                    label: "Open Modal - スタンダード - Hero Section",
                  });
                  openModal("スタンダード", true);
                }}
              >
                事前予約＆特典
              </CTAButton>
            </HeroTextContainer>
            <HeroImageContainer>
              <HeroImage
                style={{ width: 120, position: "relative", zIndex: 1 }}
                src={nooruLogo}
                alt="한국어 학습 이미지"
              />
              <VisualBox />
              <VisualWhiteBox />
            </HeroImageContainer>
          </HeroContent>
        </Wrapper>
      </HeroSection>

      {/* Feature Section */}
      <FeaturesSection id="features">
        <Wrapper>
          <FeatureSectionTitle>
            韓国語、
            <br />
            もう難しくありません！
            <br />
            月700円で <br />
            完璧な発音と表現
          </FeatureSectionTitle>
          <FeatureDescription>
            <FeatureCard>
              <FeatureTitle>K-POP</FeatureTitle>
              <FeatureDescription>
                韓国ドラマやK-POPを <br />
                もっと楽しむために！
                <br />
                楽しく簡単に学べるアプリ
                <br />
                発音チェックもバッチリ！
              </FeatureDescription>
            </FeatureCard>
            <FeatureCard>
              <FeatureTitle>楽しい</FeatureTitle>
              <FeatureDescription>
                初心者でも安心！ <br />
                楽しみながら韓国語を学べる
              </FeatureDescription>
            </FeatureCard>
            <FeatureCard>
              <FeatureTitle>簡単</FeatureTitle>
              <FeatureDescription>
                使いやすいアプリ <br />
                正確な発音を学ぼう
                <br />
                今すぐ申し込み！
              </FeatureDescription>
            </FeatureCard>
          </FeatureDescription>
        </Wrapper>
      </FeaturesSection>

      {/* Benefit Section */}
      <BenefitSection id="benefit">
        <Wrapper>
          <BenefitTitle>
            <b
              style={{
                display: "block",
                fontFamily: "Inter",
                fontSize: "16px",
                color: "rgba(88, 80, 236, 1)",
                letterSpacing: "1px",
              }}
            >
              BENEFIT
            </b>
            事前申し込み特典
          </BenefitTitle>
          <p
            style={{
              fontFamily: "Inter",
              fontSize: "18px",
              fontWeight: 400,
              color: "rgba(107, 114, 128, 1)",
              lineHeight: 1.5,
            }}
          >
            まもなく公開されます！ <br />
            今すぐ事前予約する方には
            <br />
            特別な特典がありますので、
            <br />
            ご興味のある方はこのチャンスを
            <br />
            逃さないでください！
          </p>
          <BenefitList>
            <li>
              <h4>
                ①抽選で1名様に、 <br />
                1年間無料利用権をプレゼント
              </h4>
              <p>
                長期的なサポートで、持続的に成長するチャンスを提供します。たった一人だけに与えられる特別な特典で、期待感を高めましょう！
              </p>
            </li>
            <li>
              <h4>②先着100名様に、1ヶ月無料利用権！</h4>
              <p>
                早く登録すれば、誰でも最初の1ヶ月を無料で利用できる絶好のチャンス！先着順なので、特典が終わる前にお見逃しなく！
              </p>
            </li>
            <li>
              <h4>③1週間利用して満足できなければ、 　全額返金保証！</h4>
              <p>
                ご安心ください！
                7日間、リスクなしで体験し、満足できない場合は全額返金！
              </p>
            </li>
          </BenefitList>
        </Wrapper>
      </BenefitSection>

      {/* Pricing Section */}
      <PricingSection id="pricing">
        <PricingTitle>
          <b
            style={{
              display: "block",
              fontFamily: "Inter",
              fontSize: "16px",
              color: "rgba(88, 80, 236, 1)",
              textAlign: "center",
              letterSpacing: "1px",
              lineHeight: 1.4,
              marginBottom: 5,
            }}
          >
            Pricing
          </b>
          料金プラン
        </PricingTitle>
        <PricingCards>
          <PricingCard>
            <PricingCardTitle>ライト</PricingCardTitle>
            <PricingCardPrice>¥700</PricingCardPrice>
            <PricingCardDescription>
              ( 1ヶ月/ 年間契約 )<br />
              年間契約なら2ヶ月分お得
              <br />
              月間契約の場合は￥840/月
            </PricingCardDescription>
            <PricingCardFeatures>
              <li>
                <span
                  style={{
                    color: "green",
                    marginRight: "10px",
                    fontWeight: "bold",
                  }}
                >
                  ✓
                </span>
                単語・例文　1日5つ
              </li>
              <li>
                <span style={{ color: "green", marginRight: "10px" }}>✓</span>
                発音チェック不可
              </li>
              <StartTrialButton onClick={() => openModal("ライト")}>
                Start Trial
              </StartTrialButton>
            </PricingCardFeatures>
          </PricingCard>
          <PricingCard mostPopular>
            <MOSTBadge>MOST POPULAR</MOSTBadge>
            <PricingCardTitle mostPopular>スタンダード</PricingCardTitle>
            <PricingCardPrice>¥1200</PricingCardPrice>
            <PricingCardDescription>
              ( 1ヶ月/ 年間契約 ) <br />
              年間契約なら2ヶ月分お得
              <br />
              月間契約の場合は￥1,440/月
            </PricingCardDescription>
            <PricingCardFeatures>
              <li>
                <span
                  style={{
                    color: "green",
                    marginRight: "10px",
                    fontWeight: "bold",
                  }}
                >
                  ✓
                </span>
                単語・例文　1日10つ
              </li>
              <li>
                <span
                  style={{
                    color: "green",
                    marginRight: "10px",
                    fontWeight: "bold",
                  }}
                >
                  ✓
                </span>
                発音チェック月100回
              </li>
              <StartTrialButton
                mostPopular
                onClick={() => openModal("スタンダード")}
              >
                Start Trial
              </StartTrialButton>
            </PricingCardFeatures>
          </PricingCard>
          <PricingCard>
            <PricingCardTitle>プレミアム</PricingCardTitle>
            <PricingCardPrice>¥2400</PricingCardPrice>
            <PricingCardDescription>
              ( 1ヶ月/ 年間契約 ) <br />
              年間契約なら2ヶ月分お得
              <br />
              月間契約の場合は￥2,880/月
            </PricingCardDescription>
            <PricingCardFeatures>
              <li>
                <span
                  style={{
                    color: "green",
                    marginRight: "10px",
                    fontWeight: "bold",
                  }}
                >
                  ✓
                </span>
                単語・例文　1日15つ
              </li>
              <li>
                <span
                  style={{
                    color: "green",
                    marginRight: "10px",
                    fontWeight: "bold",
                  }}
                >
                  ✓
                </span>
                発音チェック無制限
              </li>
              <StartTrialButton onClick={() => openModal("プレミアム")}>
                Start Trial
              </StartTrialButton>
            </PricingCardFeatures>
          </PricingCard>
        </PricingCards>
      </PricingSection>

      <PromoBanner
        onClick={() => {
          ReactGA.event({
            category: "Button",
            action: "Click",
            label: "Promo Banner",
          });
          openModal("スタンダード", true);
        }}
      />

      {/* Footer Section */}
      <Footer>
        <SocialLinks>
          <a href="https://facebook.com">Facebook</a>
          <a href="https://twitter.com">Twitter</a>
          <a href="https://instagram.com">Instagram</a>
        </SocialLinks>
        <p>© 2024 Nooru. All Rights Reserved.</p>
      </Footer>
      <BottomForm
        isOpen={isModalOpen}
        onClose={closeModal}
        selectedPlan={selectedPlan}
      />
    </Container>
  );
}

export default MainPage;
